module.exports = __webpack_public_path__ + "img/completed.fa51f337.svg";